import React from "react";

// Icons
import DiscoveryIcon from "../images/toolsets/discovery.svg";
import QueryIcon from "../images/toolsets/query.svg";
import StorageIcon from "../images/toolsets/storage.svg";
import FlowIcon from "../images/toolsets/flow.svg";
import ProcessIcon from "../images/toolsets/process.svg";
import ObserveIcon from "../images/toolsets/observe.svg";

// Apps
import ragflowIcon from "../images/apps/rag-flow.svg";
import ragflowRIcon from "../images/apps/rag-flow-r.svg";
import megabankIcon from "../images/apps/megabank.svg";
import megapipeIcon from "../images/apps/megapipe.svg";
import megarillIcon from "../images/apps/megarill.svg";
import megablobIcon from "../images/apps/megablob.svg";
import megalakeIcon from "../images/apps/megalake.svg";
import megagresIcon from "../images/apps/megagres.svg";
import megatrixIcon from "../images/apps/megatrix.svg";
import megaloreIcon from "../images/apps/megalore.svg";
import megastarIcon from "../images/apps/megastar.svg";
// Heros
import ToolHeroImg from "../images/hero/hero_final_app.svg";


export const UserRoleContext = React.createContext(undefined);

const AppLogo = {
  megaai: ragflowIcon,

  megabank: megabankIcon,

  megapipe: megapipeIcon,
  megarill: megarillIcon,
  megablob: megablobIcon,
  megalake: megalakeIcon,
  megagres: megagresIcon,
  megatrix: megatrixIcon,
  megalore: megaloreIcon,
  megastar: megastarIcon,
};

const AppRLogo = {
  megaai: ragflowRIcon,

  megabank: megabankIcon,

  megapipe: megapipeIcon,
  megarill: megarillIcon,
  megablob: megablobIcon,
  megalake: megalakeIcon,
  megagres: megagresIcon,
  megatrix: megatrixIcon,
  megalore: megaloreIcon,
  megastar: megastarIcon,
};

const AIApps = [
  {
    category: "AI Apps",
    apps: [
      {
        name: "MegaAI",
        icon: "",
        href: "#/app/megaai",
        link: "https://megaai.data.labillion.cn",
        doc: "https://docs.data.labillion.cn",
        state: true,
        mainColor: "#0e0f12",
        desc: "An extensible, feature-rich, and user-friendly AI platform designed to operate entirely offline.",
        heroImg: ToolHeroImg,
      },
    ],
  },
];

const DataApps = [
  {
    category: "Data Governance",
    apps: [
      {
        name: "Megastar",
        icon: "",
        href: "#/app/megastar",
        link: "https://megastar.data.labillion.cn",
        doc: "https://docs.data.labillion.cn",
        state: true,
        mainColor: "#5236ae",
        desc: "YA data catalog is an organized, searchable inventory of an organization's data assets.",
        heroImg: ToolHeroImg,
      },
    ],
  },
];


const DataInfra = [
  {
    category: "Data Marts",
    apps: [
      {
        name: "Megabank",
        icon: "",
        href: "#/app/megabank",
        link: "https://megabank.data.labillion.cn",
        doc: "https://docs.data.labillion.cn",
        state: true,
        mainColor: "#239bbb",
        desc: "Your modern workspace for discovery holo data.",
        heroImg: ToolHeroImg,
      },
    ],
  },
  {
    category: "Data Pipeline",
    apps: [
      {
        name: "Megapipe",
        icon: "",
        href: "#/app/megapipe",
        link: "https://megapipe.data.labillion.cn",
        doc: "https://docs.data.labillion.cn/megapipe",
        state: true,
        mainColor: "#d23c19",
        desc: "A lightweight, ultra-fast tool for building observability pipelines.",
        heroImg: ToolHeroImg,
      },
    ],
  },
  {
    category: "Data Modeling",
    apps: [
      {
        name: "Megarill",
        icon: "",
        href: "#/app/megarill",
        link: "https://megarill.data.labillion.cn",
        doc: "https://docs.data.labillion.cn/megarill",
        logo: "",
        state: true,
        mainColor: "#4736f5",
        desc: "Rethinks data that move as fast as your business.",
        heroImg: ToolHeroImg,
      },
    ],
  },
  {
    category: "Data Storage",
    apps: [
      {
        name: "Megablob",
        icon: "",
        href: "#/app/megablob",
        link: "https://megablob.data.labillion.cn",
        doc: "https://docs.data.labillion.cn/megablob",
        state: true,
        mainColor: "#d26313",
        desc: "A cloud-native object store built to run on any infrastructure - public, private or edge clouds.",
        heroImg: ToolHeroImg,
      },
      {
        name: "Megalake",
        icon: "",
        href: "#/app/megalake",
        link: "https://megatrix.data.labillion.cn/sqllab/",
        doc: "https://docs.data.labillion.cn/megalake",
        state: true,
        mainColor: "#FFCF25",
        desc: "The fastest analytical database for more business.",
        heroImg: ToolHeroImg,
      },
      {
        name: "Megagres",
        icon: "",
        href: "#/app/megagres",
        link: "https://megatrix.data.labillion.cn/sqllab/",
        doc: "https://docs.data.labillion.cn/megagres",
        state: true,
        mainColor: "#18A6F6",
        desc: "The fastest analytical database for more business.",
        heroImg: ToolHeroImg,
      },
    ],
  },
  {
    category: "Data Analytics",
    apps: [
      {
        name: "Megatrix",
        icon: "",
        href: "#/app/megatrix",
        link: "https://megatrix.data.labillion.cn",
        doc: "https://docs.data.labillion.cn/megatrix",
        state: true,
        mainColor: "#239bbb",
        desc: "An open-source modern data exploration and visualization platform.",
        heroImg: ToolHeroImg,
      },
      {
        name: "Megalore",
        icon: "",
        href: "#/app/megalore",
        link: "https://megalore.data.labillion.cn",
        doc: "https://docs.data.labillion.cn/megalore",
        state: false,
        mainColor: "#31d891",
        desc: "The only digital insights platform that gives you complete understanding of your data journeys.",
        heroImg: ToolHeroImg,
      },
    ],
  },
];

const SubSystems = [
  {
    id: 1,
    title: "Data Discovery",
    longDesc: "Data discovery is a data discovery and metadata engine for improving the productivity of data " +
      "analysts, data scientists and engineers when interacting with data. It does that today by " +
      "indexing data resources ...",
    link: "https://docs.data.labillion.cn/docs/en/integrations",
    icon: DiscoveryIcon,
    subSystemIcons: [
      {
        name: "Collibra",
        href: "https://docs.data.labillion.cn/docs/en/integrations",
      },
      {
        name: "Collibra",
        href: "https://docs.data.labillion.cn/docs/en/integrations",
      },
      {
        name: "Atlan",
        href: "https://docs.data.labillion.cn/docs/en/integrations",
      }
    ],
  },
  {
    id: 2,
    title: "Query Engine",
    longDesc: "Mixed real-time and ad-hoc database to power modern analytics applications. It's Easy integration " +
      "with your existing data pipelines but fast and consistent queries at high concurrency ...",
    link: "https://docs.data.labillion.cn/docs/en/integrations",
    icon: QueryIcon,
    subSystemIcons: [
      {
        name: "Presto",
        href: "https://docs.data.labillion.cn/docs/en/integrations",
      },
      {
        name: "ClickHouse",
        href: "https://docs.data.labillion.cn/docs/en/integrations",
      },
      {
        name: "Pinot",
        href: "https://docs.data.labillion.cn/docs/en/integrations",
      }
    ],
  },
  {
    id: 3,
    title: "Data Storage",
    longDesc: "Data Storage offers high-performance, S3 compatible object storage. Native to Kubernetes, also is the " +
      "only object storage suite available on every public cloud, every Kubernetes distribution, the private cloud ...",
    link: "https://docs.data.labillion.cn/docs/en/integrations",
    icon: StorageIcon,
    subSystemIcons: [
      {
        name: "Hudi",
        href: "https://docs.data.labillion.cn/docs/en/integrations",
      },
      {
        name: "HDFS",
        href: "https://docs.data.labillion.cn/docs/en/integrations",
      },
      {
        name: "MinIO",
        href: "https://docs.data.labillion.cn/docs/en/integrations",
      }
    ],
  },
  {
    id: 4,
    title: "Process Engine",
    longDesc: "Includes a cost-based optimizer, columnar storage and code generation to make queries fast. " +
      "It scales to thousands of nodes and multi hour queries using the process engine, which provides full " +
      "mid-query fault tolerance... ",
    link: "https://docs.data.labillion.cn/docs/en/integrations",
    icon: ProcessIcon,
    subSystemIcons: [
      {
        name: "Polars",
        href: "https://docs.data.labillion.cn/docs/en/integrations",
      },
      {
        name: "Spark",
        href: "https://docs.data.labillion.cn/docs/en/integrations",
      },
      {
        name: "Flink",
        href: "https://docs.data.labillion.cn/docs/en/integrations",
      },
      {
        name: "DuskSQL",
        href: "https://docs.data.labillion.cn/docs/en/integrations",
      }
    ],
  },
  {
    id: 5,
    title: "Data Flow",
    longDesc: "Scheduler executes your tasks on an array of workers while following the specified dependencies. Rich " +
      "command line utilities make performing complex surgeries on DAGs a snap. The rich user interface makes it easy " +
      "to visualize pipelines ...",
    link: "https://docs.data.labillion.cn/docs/en/integrations",
    icon: FlowIcon,
    subSystemIcons: [
      {
        name: "Airflow",
        href: "https://docs.data.labillion.cn/docs/en/integrations",
      },
      {
        name: "Dagster",
        href: "https://docs.data.labillion.cn/docs/en/integrations",
      },
      {
        name: "Prefect",
        href: "https://docs.data.labillion.cn/docs/en/integrations",
      }
    ],
  },
  {
    id: 6,
    title: "Data Observability",
    longDesc: "Removes the blind spots in your data pipelines, providing full-stack visibility and AI-powered " +
      "recommendations to drive more reliable performance in your modern data applications, wherever it’s deployed ...",
    link: "https://docs.data.labillion.cn/docs/en/integrations",
    icon: ObserveIcon,
    subSystemIcons: [
      {
        name: "Grafana",
        href: "https://docs.data.labillion.cn/docs/en/integrations",
      },
      {
        name: "Datadog",
        href: "https://docs.data.labillion.cn/docs/en/integrations",
      }
    ],
  },
];


export { AppLogo, AppRLogo, AIApps, DataApps, DataInfra, SubSystems };
